
  import { Component, Prop, Vue } from "vue-property-decorator";
  import CardBodyItem from "@/components/card/CardBodyItem.vue";
  import { NO_INFORMATION } from "@/data/placeholders";

  @Component({
    components: {
      CardBodyItem,
    }
  })
  export default class ProjectActivitySmallCard extends Vue {
    @Prop({ type: String, default: NO_INFORMATION }) readonly title!: string;
    @Prop({ type: String, default: NO_INFORMATION }) readonly startDate!: string;
    @Prop({ type: String, default: NO_INFORMATION }) readonly endDate!: string;
    @Prop({ type: Number, default: undefined }) readonly requestedHours?: number;
    @Prop({ type: Number, default: undefined }) readonly approvedHours?: number;
    @Prop({ type: Number, default: undefined }) readonly budget?: number;

    get containerClasses(): string {
      if (!this.requestedHours) {
        return "border-yellow-400";
      }
      return "border-green-400";
    }
  }
